export * from './design-system-provider';

//# sourceMappingURL=index.js.map